import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MainBannerComponent } from "../../components/main-banner/main-banner.component";
import { HomepageCirclesComponent } from "../../includes/homepage-circles/homepage-circles.component";
import { TestimonialSliderComponent } from "../../components/testimonial-slider/testimonial-slider.component";
import { SeatBeltComponent } from '../../components/seat-belt/seat-belt.component';
import { Router, NavigationEnd } from '@angular/router';
import { BannerSliderComponent } from "../../components/banner-slider/banner-slider.component";
import { BannerSliderImage } from '../../models/banner-slider-image.model';
import { MetaService } from '../../services/meta.service';

@Component({
  selector: 'pc-home',
  standalone: true,
  imports: [
    MainBannerComponent,
    HomepageCirclesComponent,
    RouterLink,
    TestimonialSliderComponent,
    SeatBeltComponent,
    BannerSliderComponent
],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {
  viewHeight: number | undefined;
  viewWidth: number | undefined;
  isMobile: boolean | undefined;

  bannerImages: Array<BannerSliderImage> = [];
  
  constructor(
    private router: Router,
    private metaService: MetaService,
  ) { }

  ngOnInit(): void {

    this.metaService.setMetadata('pc-home');

    // Make sure we're at top of page
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });


    this.bannerImages = [
      {
        url: 'https://tsgblob.blob.core.windows.net/pc-haines/assets/images/home/slider-1'
      },
      {
        url: 'https://tsgblob.blob.core.windows.net/pc-haines/assets/images/home/slider-2'
      },
      {
        url: 'https://tsgblob.blob.core.windows.net/pc-haines/assets/images/home/slider-3'
      },
      {
        url: 'https://tsgblob.blob.core.windows.net/pc-haines/assets/images/home/slider-4'
      },
      {
        url: 'https://tsgblob.blob.core.windows.net/pc-haines/assets/images/home/slider-5'
      },
      {
        url: 'https://tsgblob.blob.core.windows.net/pc-haines/assets/images/home/slider-6'
      }
    ]
  }

}
